__turbopack_context__.v({
  "errorBanner": "errorBanner-module-scss-module__kNJwba__errorBanner",
  "errorBanner__close": "errorBanner-module-scss-module__kNJwba__errorBanner__close",
  "errorBanner__content": "errorBanner-module-scss-module__kNJwba__errorBanner__content",
  "errorBanner__icon": "errorBanner-module-scss-module__kNJwba__errorBanner__icon",
  "errorBanner__message": "errorBanner-module-scss-module__kNJwba__errorBanner__message",
  "errorBanner__title": "errorBanner-module-scss-module__kNJwba__errorBanner__title",
  "slideIn": "errorBanner-module-scss-module__kNJwba__slideIn",
});
